import Constants from 'constants';

const getForgetData = (response = {}) => {
    const { status = {} } = response;
    const { success = false } = status;
    let type = Constants.actions.USER.FORGET_PASSWORD_SUCCESS;
    if (!success) {
        type = Constants.actions.USER.FORGET_PASSWORD_FAILURE;
    }
    return {
        type,
        payload: response
    };
};

export default getForgetData;